<div *ngIf="loadingTicket" class="d-flex flex-column align-items-center justify-content-center" style="min-height: 100vh;">
  <span>Revcollect ticket loading...</span>
</div>
<div class="container-fluid bg-light min-vh-100 py-4 py-md-5" *ngIf="!loadingTicket">



  <div class="container">

    <div
      class="bg-white shadow-lg rounded-4 overflow-hidden mx-auto"
      style="max-width: 1100px;">

      <div class="row g-0">

        <div class="col-lg-8 d-flex flex-column justify-content-between">

          <div class="bg-primary p-4 p-md-5 text-white">

            <div
              class="d-flex align-items-center justify-content-between">

              <div
                class="d-flex align-items-center gap-3">
                <div>
                  <h3 class="fw-bold mb-1">
                    TICKET DETAILS
                  </h3>
                  <p class="mb-0 opacity-75">
                    <span *ngIf="isTicketValid === 'valid' || isTicketValid === 'not-valid'" >{{category === 'Traders' ? 'Market' : 'Transport'}}</span> Revenue Collection
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="px-4 px-md-5 pt-4">

            <div
              [ngClass]="{'alert-success': isTicketValid === 'valid', 'alert-danger': isTicketValid === 'not-valid' || isTicketValid === 'not-found'}"
              class="alert border-0 rounded-3 d-flex align-items-center mb-4" style="gap: 3px;">

              <i *ngIf="isTicketValid === 'valid'"
                class="text-success fa fa-check-circle fs-4 align-self-start mt-1">
              </i>
              <i
                *ngIf="isTicketValid === 'not-valid' || isTicketValid === 'not-found'"
                class="text-danger fa fa-exclamation-triangle fs-4 align-self-start mt-1">
              </i>

              <div>

                <div class="fw-bold text-mute">
                  {{ isTicketValid === 'valid' ? 
                  'Ticket is valid for today' : 
                  isTicketValid === 'not-valid' ? 
                  'Ticket is not valid for today' :
                  'Ticket not found'}}
                </div>


              </div>

            </div>

          </div>

          <div class="px-4 px-md-5" *ngIf="isTicketValid === 'valid' || isTicketValid === 'not-valid'">

            <div class="row g-4" >
              <div class="col-md-6 mb-3">

                <div
                  class="d-flex align-items-center"
                  style="gap: 10px">

                  <div
                    class="bg-white bg-opacity-10 text-primary rounded-3 p-3">

                    <i
                      class="fa fa-calendar fs-4 text-primary">
                    </i>

                  </div>

                  <div>

                    <small
                      class="text-muted text-uppercase fw-semibold">

                      Payment Date

                    </small>

                    <h5 class="fw-bold mb-0 mt-1">
                      {{ticketingInfo['issued_at']}}
                    </h5>

                  </div>

                </div>

              </div>

              <div class="col-md-6 mb-3">

                <div
                  class="d-flex align-items-center"
                  style="gap: 10px;">

                  <div
                    class="bg-white bg-opacity-10 text-primary rounded-3 p-3">

                    <i class="fa fa-motorcycle fs-4 text-primary"></i>

                  </div>

                  <div>

                    <small
                      class="text-muted text-uppercase fw-semibold">

                      Ticket Type

                    </small>

                    <h5 class="fw-bold mb-0 mt-1">
                      {{ category === 'Traders' ? 'TRADER' :  'RIDER'}}
                    </h5>

                  </div>

                </div>

              </div>
              <div class="col-md-6 mb-3">

                <div
                  class="d-flex align-items-center"
                  style="gap: 10px;">

                  <div
                    class="bg-white bg-opacity-10 text-primary rounded-3 p-3">

                    <i class="fa fa-motorcycle fs-4 text-primary"></i>

                  </div>

                  <div>

                    <small
                      class="text-muted text-uppercase fw-semibold">

                      Amount

                    </small>

                    <h5 class="fw-bold mb-0 mt-1">
                      ₦{{ticketingInfo['amount']}}
                    </h5>

                  </div>

                </div>

              </div>
              <div class="col-md-6 mb-3">

                <div
                  class="d-flex align-items-center"
                  style="gap: 10px;">

                  <div
                    class="bg-white bg-opacity-10 text-primary rounded-3 p-3">

                    <i class="fa fa-motorcycle fs-4 text-primary"></i>

                  </div>

                  <div>

                    <small
                      class="text-muted text-uppercase fw-semibold">

                        PAYMENT METHOD

                    </small>

                    <h5 class="fw-bold mb-0 mt-1">
                      Cash
                    </h5>

                  </div>

                </div>

              </div>
              <div class="col-md-6 mb-3">

                <div
                  class="d-flex align-items-center"
                  style="gap: 10px;">

                  <div
                    class="bg-white bg-opacity-10 text-primary rounded-3 p-3">

                    <i class="fa fa-motorcycle fs-4 text-primary"></i>

                  </div>

                  <div>

                    <small
                      class="text-muted text-uppercase fw-semibold">

                      Rider / Trader Name

                    </small>

                    <h5 class="fw-bold mb-0 mt-1">
                      {{ticketingInfo['operator_identifier']}}
                    </h5>

                  </div>

                </div>

              </div>
              <div class="col-md-6 mb-3">

                <div
                  class="d-flex align-items-center"
                  style="gap: 10px;">

                  <div
                    class="bg-white bg-opacity-10 text-primary rounded-3 p-3">

                    <i class="fa fa-motorcycle fs-4 text-primary"></i>

                  </div>

                  <div>

                    <small
                      class="text-muted text-uppercase fw-semibold">

                        AGENT NAME

                    </small>

                    <h5 class="fw-bold mb-0 mt-1">
                      {{ticketingInfo['agent_name']}}
                    </h5>

                  </div>

                </div>

              </div>

            </div>

          </div>

          <div
            class="p-4 px-md-5 bg-primary bg-opacity-10">

            <div
              class="d-flex flex-column flex-md-row justify-content-between gap-3">

              <div class="d-flex gap-3">

                <i
                  class="fa fa-shield text-primary fs-3">
                </i>

                <div>

                  <div class="fw-semibold text-white">
                    Payment Verified
                  </div>

                  <small class="text-white">

                    Thank you for your payment.
                    Drive safely and obey traffic rules.

                  </small>

                </div>

              </div>

              <div class="text-md-end">

                <small class="text-white d-block">
                  Powered by
                </small>

                <span
                  class="fw-bold text-white">
                  <a class="text-white" href="https://upperlink.ng/" target="_blank">Upperlink</a>

                   limited.

                </span>

              </div>

            </div>

          </div>

        </div>

        <div
          class="col-lg-4 border-start"
          style="background: #fbfcff;">

          <div
            class="h-100 d-flex flex-column text-center p-4 p-md-5">
            <h5 class="fw-bold text-primary mb-1">
              {{category === 'Traders' ? 'MARKET' : 'TRANSPORT'}}
            </h5>

            <small class="text-muted">
              REVENUE AUTHORITY
            </small>

            <hr class="w-100 my-4">

            <div>

              <small
                class="text-muted text-uppercase fw-semibold">

                Ticket ID

              </small>

              <h5
                class="fw-bold text-primary mt-2">

                {{ currentTicketId}}

              </h5>

            </div>

            <div class="mt-4">

              <small
                class="text-muted text-uppercase fw-semibold">

                Ticket Status

              </small>

              <div class="mt-2 text-white">

                <span
                  class="badge bg-primary px-3 py-2">

                  <i
                    class="fa fa-check-circle me-1">
                  </i>

                  PAID 

                </span>

              </div>

            </div>

            <div *ngIf="isTicketValid === 'valid'"
              class="border border-primary rounded-3 px-3 py-3 mt-4">

              <div
                class="d-flex align-items-center justify-content-center " style="gap: 3px;">

                <i
                  class="fa fa-clock-o text-primary mt-1">
                </i>

                <span
                  class="small fw-semibold text-primary">

                  VALID TODAY

                </span>

              </div>

              <small class="text-muted d-block mt-1">
                Expires at 11:59 PM
              </small>

            </div>

            <div
              class="border-top w-100 pt-4 mt-5">

              <div
                class="bg-primary bg-opacity-10 rounded-3 p-4">

                <i
                  class="fa fa-shield text-primary fs-1">
                </i>

                <h6 class="fw-bold mt-3 text-white">
                  Payment Verified
                </h6>

                <p class="text-white small mb-0">

                  This ticket confirms that the daily
                  revenue fee has been successfully
                  recorded in the revenue collection system.

                </p>

              </div>

            </div>

            <div class="mt-auto pt-4">

              <small class="text-white">

                Keep this ticket available for inspection
                by authorized officers.

              </small>

            </div>

          </div>

        </div>

      </div>

    </div>


  </div>

</div>